var sw_mwjp_widget = {};
sw_mwjp_widget.main = {};
sw_mwjp_widget.main.createElement = function (type, attributesMatrix, innerHTML, featureId) {
    if (!featureId || document.getElementById(featureId) === null) {
        var itemDiv;
        attributesMatrix.forEach(attribute => {
            if (attribute[0] === "id") {
                let element = document.getElementById(attribute[1]);
                if (element) {
                    itemDiv = element;
                }
            }
        });
        if (!itemDiv) {
            itemDiv = document.createElement(type);
        }

        attributesMatrix.forEach(attribute => itemDiv.setAttribute(attribute[0], attribute[1]));
        if (innerHTML) {
            itemDiv.innerHTML = innerHTML;
        }
        return itemDiv;
    }
    return undefined;
};

document.addEventListener("visibilitychange", function() {
    if (document.hidden){

        sw_mwjp_widget.tickers.clearIntervals();
    }/* else {
        console.log("Browser tab is visible")
    }*/
});

sw_mwjp_widget.main.appendCssToHead = function (value) {
    if (!value) {
        return;
    }

    const styleTag = document.createElement('style');
    const head =
        document.head || document.getElementsByTagName('head')[0];
    styleTag.type = 'text/css';
    styleTag.innerHTML = value;
    head.appendChild(styleTag);
};